import { lazy } from 'react';
import { Loadable } from './Loadable';
import { PATH_DASHBOARD } from './paths';

const ticketsRoutes = [
  {
    component: Loadable(lazy(() => import('../pages/tickets/Requerimientos'))),
    path: PATH_DASHBOARD.tickets.requerimientos.path,
    shouldRender: PATH_DASHBOARD.tickets.requerimientos.renderCondition,
  },
  {
    component: Loadable(lazy(() => import('../pages/tickets/Incidentes'))),
    path: PATH_DASHBOARD.tickets.incidentes.path,
    shouldRender: PATH_DASHBOARD.tickets.incidentes.renderCondition,
  },
];

export default ticketsRoutes;
